module.exports = __webpack_public_path__ + "static/media/information.c6812dd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/information.svg
// module id = 376
// module chunks = 36